import { render } from "./djRecharge.vue?vue&type=template&id=7fd485fe&scoped=true"
import script from "./djRecharge.vue?vue&type=script&lang=js"
export * from "./djRecharge.vue?vue&type=script&lang=js"

import "./djRecharge.vue?vue&type=style&index=0&id=7fd485fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fd485fe"

export default script